// Official Vue compilers
const vue_2_6_11_compiler = require("vue-template-compiler")

/**
 * compiler for version 2_6_11
 * @param {string} vueTemplate
 */
const compiler2_6_11 = ({ vueTemplate }) => {
	if (!vueTemplate) return ""

	// https://github.com/vuejs/vue/blob/dev/flow/compiler.js
	// Get script tag content
	const script = vue_2_6_11_compiler.parseComponent(vueTemplate)?.script?.content ?? ""

	// Remove `imports...` and `export default`
	// Remove `components: { ... }`
	// Remove `mixins: []`
	// scriptContent is essentially  a Vue component object `{ data(){}... }`
	let scriptContent = script
		?.replace(/.*export default/s, "")
		.replace(/components:.?{(\n|(?!}).)*},/, "")
		.replace(/mixins:.?\[(\n|(?!]).)*\],/, "")

	return scriptContent
}

/**
 * Versioned compilers
 */
const compilersProvider = {
	"2.6.11": compiler2_6_11
}

/**
 * compileVueTemplateToEditorScript
 * @param {string} vueTemplate
 * @param {string} version
 */
export default ({ vueTemplate, version = "" }) => {
	const compiler = compilersProvider[version]
	if (!compiler) throw new Error(`There is no compiler for Vue of version ${version} available`)

	return compiler({ vueTemplate })
}
